
<script>
import BarList from '../components/bar-list'
import DepoForm from './depo-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            deposito: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        depositoList: function () {
            return this.$store.getters.getDepositoList
        },
        nextPage: function () {
            return this.$store.getters.getNextPage
        }
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.coddeposito = cod
            this.showForm = true;
        },

        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.coddeposito = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"coddeposito":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadDeposito', { filter: this.filter, page: this.offset } )
            this.offset = ''
        }

    },

    components: {
        BarList, DepoForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm">
            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                single-entity="Depósito"
                plural-entity="Depósitos"
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container nb-card-list">
                <alert v-if="depositoList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="deposito in depositoList" :key="deposito.coddeposito">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-archive" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ deposito.descricao }}</h2>
                                </div>
                                <div class="nb-card-code" v-if="deposito.coddeposito">
                                    Código <strong>{{ deposito.coddeposito }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid
                                :options="{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'}"
                                :moreActions="[]"
                                v-on:edit="handleEdit(deposito.coddeposito)"
                                v-on:view="handleEdit(deposito.coddeposito, true)">
                            </bar-grid>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <depo-form v-if="showForm" :index="this.coddeposito" :crud="this.crud" v-on:closeform="closeForm"></depo-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-actions {
  flex: 0 0 auto;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/depo-list.vue